import index from '../api/index'

export const Get = () => {
    return new Promise((resolve) => {
        resolve(index.percent.Get())
    })
}

export const Add = (query) => {
    return new Promise((resolve) => {
        resolve(index.percent.Add(query))
    })
}

export const Delete = (query) => {
    return new Promise((resolve) => {
        resolve(index.percent.Delete(query))
    })
}